import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

// Отправить запрос на поиск RU-акций по запросу
export const searchRuStocksBriefcase = async (query) => {
  const url = `${backendUrl}/api/search/ru-stocks?q=${encodeURIComponent(query)}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при поиске RU-акций: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка при поиске RU-акций:', error);
    throw error;
  }
};
